import ModuleWrapper from 'shared-lib/containers/Module';

const ApprovalsDefault  = () => import(/* webpackChunkName: "approvals-default" */ '@/views/approvals/ApprovalsDefault');
const ApprovalDetails  = () => import(/* webpackChunkName: "approval-details" */ '@/views/approvals/ApprovalDetails');
const meta = (data = {}) => ({
    permissionsModuleName: 'approvals',
    auth: true,
    ...data,
});
import { marketplaceRouteGuard } from '@/router/helpers/routeGuards';

export default [{
    path: 'approvals',
    component: ModuleWrapper,
    meta: meta({
        permission: 'list',
        title: 'Approvals',
    }),
    children: [
        {
            path: '',
            name: 'Approvals',
            component: ApprovalsDefault,
            meta: meta({
                permission: 'list',
            }),
            beforeEnter: marketplaceRouteGuard,
        },
        {
            path: ':id',
            name: 'ApprovalDetails',
            component: ApprovalDetails,
            props: true,
            meta: meta({
                permission: 'list',
            }),
            beforeEnter: marketplaceRouteGuard,
        },
    ],
}];
